@if (showAiPrompt) {
	<panel width="400">
		<h1>{{ 'query.ai.header' | translate }}</h1>
		<section>
			<custom-input [label]="'query.ai.prompt' | translate" [inputType]="inputTypeEnum.Textarea" [(value)]="aiPrompt" [placeholder]="'query.ai.prompt-placeholder' | translate" />
		</section>
		<section>
			<button [asyncCallback]="sendPrompt" [label]="'query.ai.send' | translate" [ignoreValidation]="true" [active]="aiPrompt.trim() != ''"></button>
			@if (aiReply) {
				<p>{{ aiReply.message }}</p>
			}
		</section>
	</panel>
}
<panel>
	@if (loading) {
		<h1><skeleton /></h1>
		<skeletons [defaultSkeletons]="5" />
	}
	@else {
		<h1>{{ title }}</h1>
		<scrollable>
			@if (!query.id && !showAiPrompt && !activeEditableQuery) {
				<section>
					<button [ignoreValidation]="true" [loader]="false" (click)="showAiPrompt = true">{{ 'query.ai.get-help' | translate }}</button>
				</section>
			}
			<section>
				<custom-input [label]="'query.name' | translate" [inputType]="inputTypeEnum.Text" [(value)]="query.name" [placeholder]="'query.name-placeholder' | translate" [required]="true" />
				<custom-input [label]="'query.description' | translate" [inputType]="inputTypeEnum.Textarea" [(value)]="query.description" [placeholder]="'query.description-placeholder' | translate" />

				@if ((query.id || activeEditableQuery) && queryType != undefined) {
					<text-group>
						<label>{{ 'query.query-type' | translate }}</label>
						<div>{{ 'enum.query-type.' + queryTypeEnum[queryType] | translate }}</div>
					</text-group>
				}
				@if (!query.id && !activeEditableQuery) {
					<custom-select [selectList]="queryTypeList"
									[label]="'query.query-type' | translate"
									[placeholder]="'query.query-type-placeholder' | translate"
									[required]="true"
									[(value)]="queryType"
									(valueChange)="loadProperties(true)" />
				}
			</section>
			@if (editableQueries.length > 0) {
				<h2>{{ 'query.sub-queries' | translate }}</h2>
				<list-view>
					<header [sortColumn]="false">{{ 'query.column.query-name' | translate }}</header>
					<header [sortColumn]="false">{{ 'query.query-type' | translate }}</header>
					<row *listData="let editableQuery from editableQueries" [highlighted]="editableQuery == activeEditableQuery" (action)="showEditableQuery(editableQuery)">
						<column>{{ editableQuery.query.name }}</column>
						<column>{{ 'enum.query-type.' + queryTypeEnum[editableQuery.queryType] | translate }}</column>
					</row>
				</list-view>
			}
			@if (queryProperties) {
				<section>
					<button circle (click)="showTab = 'filters'" [selected]="showTab == 'filters'" [loader]="false" [ignoreValidation]="true"><icon type="filter" /></button>
					<button circle (click)="showTab = 'selectProperties'" [selected]="showTab == 'selectProperties'" [loader]="false" [ignoreValidation]="true"><icon type="list-check" /></button>
					<button circle (click)="showRunTab()" [selected]="showTab == 'run'" [loader]="false" [ignoreValidation]="true" [active]="canShowRunTab()"><icon type="chevron-right" /></button>
				</section>

				<h2 [hidden]="showTab != 'filters'">{{ 'query.filters' | translate }}</h2>
				<list-view [hidden]="showTab != 'filters'" [selectable]="false">
					<header [sortColumn]="false">{{ 'query.column.property' | translate }}</header>
					<header [sortColumn]="false">{{ 'query.column.operator' | translate }}</header>
					<header [sortColumn]="false">{{ 'query.column.value' | translate }}</header>
					<header [sortColumn]="false"></header>
					<row *listData="let filter from queryData.filters">
						<column><custom-select [selectList]="queryPropertiesList" [placeholder]="'query.property-placeholder' | translate" [required]="true" [value]="filter.property?.name" (valueChange)="setFilterProperty(filter, $event)" /></column>
						<column><custom-select [selectList]="filter.operatorsList" [placeholder]="'query.operator-placeholder' | translate" [required]="true" [(value)]="filter.operator" /></column>
						<column>
							<custom-input [disabled]="true" [value]="getFilterValueLabel(filter)" />
							@if (isQueryReference(filter.value)) {
								<icon type="chevron-right" (click)="$event.stopPropagation(); showReferencedQuery(filter)" />
							}
						</column>
						<column>
							<icon [ngClass]="{ 'disabled': queryData.filters.length == 1 }" (click)="$event.stopPropagation(); removeFilter(filter)" type="trash-alt" />
						</column>
					</row>
				</list-view>
				<section [hidden]="showTab != 'filters'">
					<button (click)="addFilter();" [ignoreValidation]="true" [loader]="false">
						<icon type="plus" />
						{{ 'query.add-filter' | translate }}
					</button>
				</section>

				<h2 [hidden]="showTab != 'selectProperties'">{{ 'query.properties' | translate }}</h2>
				<list-view [hidden]="showTab != 'selectProperties'" [selectable]="false">
					<header [sortColumn]="false">{{ 'query.column.property' | translate }}</header>
					<header [sortColumn]="false">{{ 'query.column.is-hidden' | translate }}</header>
					<header [sortColumn]="false">{{ 'query.column.format' | translate }}</header>
					<header [sortColumn]="false">{{ 'query.column.aggregation' | translate }}</header>
					<header [sortColumn]="false"></header>
					<row *listData="let property from queryData.selectProperties">
						<column><custom-select [selectList]="selectPropertiesList" [placeholder]="'query.select-properties.placeholder' | translate" [required]="true" [value]="property.name" (valueChange)="setSelectProperty(property, $event)" /></column>
						<column><custom-input [inputType]="inputTypeEnum.Switch" [(value)]="property.isHidden" /></column>
						<column><custom-select [selectList]="availableFormatTypes(property)" [placeholder]="'query.format-placeholder' | translate" [required]="true" [(value)]="property.type" /></column>
						<column>
							@if (property.isArray && !property.isHidden) {
								<custom-select [selectList]="aggregationTypeList" [placeholder]="'query.aggregation-type-placeholder' | translate" [required]="true" [(value)]="property.aggregationType" />
							}
						</column>
						<column>
							<icon [ngClass]="{ 'disabled': queryData.selectProperties.length == 1 }" (click)="$event.stopPropagation(); removeSelectProperty(property)" type="trash-alt" />
						</column>
					</row>
				</list-view>

				<section [hidden]="showTab != 'selectProperties'">
					<button (click)="addSelectProperty();" [ignoreValidation]="true" [loader]="false">
						<icon type="plus" />
						{{ 'query.add-select-property' | translate }}
					</button>
				</section>

				@if (canShowRunTab()) {
					<query-inputs [hidden]="showTab != 'run'" [name]="query.name" [query]="runQueryData" />
					<section [hidden]="showTab != 'run'">
						<button #runQueryButton
								(click)="runQuery()"
								[label]="'query.run' | translate"
								[ignoreValidation]="true"
								[loader]="false"
								[active]="canExecute()"></button>
					</section>
				}
			}
		</scrollable>
		<section>
			<button confirm (click)="saveQuery()" [allowWhenPristine]="true">{{ 'query.save' | translate }}</button>
		</section>
	}
</panel>

@if (results) {
	<panel>
		<h1>{{ 'query.result' | translate }}</h1>
		<list-view scrollable>
			@for (property of visibleSelectProperties; track property) {
				<header [sortColumn]="false">{{ 'query.' + queryService.getPropertyHeader(queryData.queryType, property) | translate }}</header>
			}
			<row *listData="let result from results">
				@for (property of visibleSelectProperties; track property) {
					<column>{{ queryService.getPropertyValue(result, property) }}</column>
				}
			</row>
		</list-view>
	</panel>
}
